import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';

import signInForm from '@grins/fd-modules/bonz/signIn/signIn';

import perksModal from '@grins/fd-modules/bonz/shared/perksModal';

function run() {
  debugLog.info('bonz/signIn/signIn.app', 'ready');
  signInForm.init();
  perksModal.init();
}
run();
